import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AccountListMenu from "@store/Components/Store/MyAccount/AccountListMenu";
import { popoverStyles } from "@store/theme/common/mixins";
import isWebsiteAccessedByMobileApp from "@store/utilities/isWebsiteAccessedByMobileApp";
import * as React from "react";
import { css } from "styled-components";

interface SideMenuStyles {
    wrapper: InjectableCss;
}

const sideMenuStyles: SideMenuStyles = {
    wrapper: {
        css: css`
        	${popoverStyles()}
        `
    }
}

const styles = sideMenuStyles;

const SideMenu = () => {
    const isAppMobileView = isWebsiteAccessedByMobileApp();

    return (
        <>
        {!isAppMobileView && (
            <StyledWrapper {...styles.wrapper}>
                    <AccountListMenu />
            </StyledWrapper>
        )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: SideMenu,
    definition: {
        group: "Basic",
        icon: "link-simple",
        fieldDefinitions: [],
    },
};

export default widgetModule;
